module.exports = __webpack_public_path__ + "static/media/leclerc1.3a197221.jpg";